import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    siteName: 'Kentech Phones',
    logo: '/kentech-logo.jpeg',
    tagline: 'Your #1 Phone Repair Specialist',
    bankDetails: {
      accountName: 'KENTECH PHONES LTD',
      sortCode: '40-18-00',
      accountNumber: '21621653'
    },
    homeHero: {
      title: 'Kentech Phones',
      subtitle: 'Premium Device Repair & Services',
      ctaText: 'Book a Repair',
      backgroundType: 'video',
      backgroundMedia: '/videos/hero-video.mp4',
      overlayColor: '#ffffff',
      overlayOpacity: 0.1
    },
    aboutHero: {
      title: 'About Kentech Phones',
      subtitle: 'Your trusted tech partners for phones, tablets, watches, consoles and more.',
      backgroundType: 'animation',
      backgroundMedia: '',
      overlayColor: '#ffffff',
      overlayOpacity: 0
    }
  });
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/settings');
      
      if (!response.ok) {
        throw new Error('Failed to fetch settings');
      }
      
      const data = await response.json();
      setSettings(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching settings:', err);
      setError(err.message);
      // Keep default settings on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const refreshSettings = () => {
    fetchSettings();
  };

  const value = {
    settings,
    loading,
    error,
    refreshSettings
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;